const createAction = type => payload => {
  return { type, payload };
};

export const changeTemplateName = createAction('CHANGE_TEMPLATE_NAME');
export const changeTemplateIcon = createAction('CHANGE_TEMPLATE_ICON');
export const setTemplateIconUrl = createAction('SET_TEMPLATE_ICON_URL');

export const changePointsPerPlay = createAction('SET_POINTS_PER_PLAY');
export const changePointsPerWin = createAction('SET_POINTS_PER_WIN');
